import axios from 'axios';
import LocalStorageService from '../services/LocalStorageService';

export const publicUrl = process.env.REACT_APP_BACKEND_URL;
const service = LocalStorageService.getService();

export const instance = axios.create();
instance.defaults.baseURL = `${publicUrl}/account-registration/rest/`;
instance.defaults.headers.common.Accept =
  'application/json, application/octet-stream, image/jpeg, image/jpg, image/png, text/plain; application/pdf;';
instance.defaults.headers.common['Content-Type'] = 'application/json, multipart/form-data';
instance.defaults.headers.post['Access-Control-Allow-Origin'] = '*';
instance.defaults.headers.post['Access-Control-Allow-Methods'] = '*';

instance.interceptors.request.use(
  (config) => {
      if(isServicePrivate(config.url)) {
          const token = service.getAccessToken();
          config.headers.Authorization = `${token}`;
      }
   return config;
  },
  (error) => Promise.reject(error),
)

const isServicePrivate = (url) => {
    return !(url.match('public'));
}
// TODO interceptor to response. Check 40X status
